import type { IChosenItemParams } from "app/components/compare/WebsiteQueryBar/WebsitePageQueryBarUtils";
import { safeJsonParse } from "app/UtilitiesAndConstants/UtilityFunctions/safeJsonParse";

const createRangeFilterQueryParamValue = (
    queryParamPrefix: string,
    fromValue: string | number,
    toValue: string | number,
) => {
    const SECTION_DELIMITER = ",";
    if (!fromValue && !toValue) {
        return null;
    }
    return queryParamPrefix + SECTION_DELIMITER + (fromValue ?? String()) + SECTION_DELIMITER + (toValue ?? String());
};
export const getRangeFilterQueryParamValue = (config: IRangeFilter[] = []) => {
    const RANGE_FILTER_QUERY_PARAMS_DELIMITER = "|";
    const ranges = config
        .map((item) => {
            return createRangeFilterQueryParamValue(item.name, item.fromValue, item.toValue);
        })
        .filter((range) => range);
    if (ranges.length === 0) {
        return null;
    }
    return ranges.join(RANGE_FILTER_QUERY_PARAMS_DELIMITER);
};

interface IRangeFilter {
    name: string;
    fromValue: string | number;
    toValue: string | number;
}

export const createCpcFilter: (fromValue: string, toValue: string, name?: string) => IRangeFilter = (
    fromValue,
    toValue,
    name = "cpc",
) => {
    return {
        name,
        fromValue,
        toValue,
    };
};
export const createVolumeFilter: (fromValue: string, toValue: string, name?: string) => IRangeFilter = (
    fromValue,
    toValue,
    name = "kwvolume",
) => {
    return {
        name,
        fromValue,
        toValue,
    };
};
export const createPositionFilter: (
    fromValue: string,
    toValue: string,
    name: string,
    pageFilter: string,
) => IRangeFilter = (fromValue, toValue, name, pageFilter) => {
    const updatedName = convertPageFilterToPositionName(name, safeJsonParse(pageFilter, []));
    return {
        name: updatedName,
        fromValue,
        toValue,
    };
};

const convertPageFilterToPositionName = (name: string, pageFilter: IChosenItemParams): string => {
    return `competitor_${pageFilter.findIndex((item) => item.url === name)}_top_position`;
};
export const createComparePositionFilter: (positions: string, pageFilter: string) => IRangeFilter[] = (
    positions,
    pageFilter,
) => {
    let fromPosition, toPosition, positionName, positionValue;
    return positions.split(",").map((item) => {
        [positionName, positionValue] = item.split(":");
        [fromPosition, toPosition] = positionValue.split("-");
        return createPositionFilter(fromPosition, toPosition, positionName, pageFilter);
    });
};
